import 'styles/pages/index.scss';
import '~scripts/main';

// Packages
import Vue from 'vue';
import eases from 'eases';

// Swiper
import Swiper from 'swiper';
import { Autoplay, EffectFade, Navigation as SwiperNavigation, Pagination as SwiperPagination } from 'swiper/modules';
Swiper.use([Autoplay, EffectFade, SwiperNavigation, SwiperPagination]);

// Core
import { BREAKPOINTS } from '~scripts/core/breakpoints';
import { scrollAnimationProgress } from '~scripts/core/animations';

// Blocks
import Header from '~scripts/blocks/header';
import Navigation from '~scripts/blocks/navigation';
import ClientsLogotypes from '~scripts/blocks/vue/ClientsLogotypes.vue';
import initRequestForm from '~scripts/blocks/request-form';
import '~scripts/blocks/events/forum-2023/forum-results';
import '~scripts/blocks/events/forum-2023/modal-video';

// Components
import '~scripts/components/modals';
import SubscribeForm from '~scripts/components/vue/forms/SubscribeForm.vue';

// Breakpoints
const mediaSm = window.matchMedia(`(max-width: ${BREAKPOINTS.smMax})`);
const mediaMd = window.matchMedia(`(min-width: ${BREAKPOINTS.mdMin})`);
const mediaLg = window.matchMedia(`(min-width: ${BREAKPOINTS.lgMin})`);
const mediaXl = window.matchMedia(`(min-width: ${BREAKPOINTS.xlMin})`);

// Storage
const storage = window.localStorage;

// Variables
const region = window.region;

//
// HEADER
//
Header();

//
// NAVIGATION
//
Navigation();

//
// NEW ALERT
//
const newAlertEl = document.getElementById('newAlert');

if (newAlertEl) {
  const newAlertData = newAlertEl.dataset.alert;
  const newAlertCloseEl = document.getElementById('newAlertClose');

  if (!storage.getItem(newAlertData) || storage.getItem(newAlertData) !== 'none') {
    newAlertEl.style.display = 'block';
  }

  newAlertCloseEl.addEventListener('click', (e) => {
    e.preventDefault();
    storage.setItem(newAlertData, 'none');
    newAlertEl.style.display = 'none';
  });
}

//
// HUNTFLOW BLOCK
//
const handleHuntflowBlockAnimation = () => {
  const huntflowBlockAnimation = document.getElementById('huntflowBlockAnimation');
  const huntflowBlockWindow = document.getElementById('huntflowBlockWindow');

  return scrollAnimationProgress(huntflowBlockAnimation, {
    getStart() {
      let start = 0;

      if (mediaMd.matches) {
        start = 250;
      }

      if (mediaLg.matches) {
        start = 150;
      }

      return start;
    },
    getEnd() {
      const height = huntflowBlockWindow.offsetHeight;
      const end = mediaSm.matches ? height * 1.25 : height;
      return end / 2 + 100;
    },
    lerpValue: 0.25,
  });
};

handleHuntflowBlockAnimation();
mediaSm.addEventListener('change', handleHuntflowBlockAnimation);
mediaMd.addEventListener('change', handleHuntflowBlockAnimation);
mediaLg.addEventListener('change', handleHuntflowBlockAnimation);
mediaXl.addEventListener('change', handleHuntflowBlockAnimation);

//
// CLIENTS
//
new Vue({
  el: '#VClientsLogotypes',
  name: 'VClientsLogotypes',
  components: {
    ClientsLogotypes,
  },
});

//
// KEY FEATURES
//
//
// Sliders
//
const keyFeaturesSliderOptionsBase = {
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
};
const keyFeaturesSliderOptionsSm = {
  allowTouchMove: true,
  effect: 'slide',
  loop: false,
  navigation: false,
  noSwiping: false,
  slidesPerView: 'auto',
  spaceBetween: 12,
};
const keyFeaturesSliderOptionsMd = {
  allowTouchMove: false,
  effect: 'fade',
  loop: true,
  navigation: false,
  noSwiping: true,
  slidesPerView: 1,
  slidesOffsetBefore: 0,
  slidesOffsetAfter: 0,
  spaceBetween: 0,
};

let keyFeaturesSlider = null;

const handleKeyFeaturesSliderInit = () => {
  if (keyFeaturesSlider) {
    keyFeaturesSlider.forEach((slider) => {
      slider.destroy();
    });
  }

  const options = mediaSm.matches ? keyFeaturesSliderOptionsSm : keyFeaturesSliderOptionsMd;

  keyFeaturesSlider = new Swiper('.js-key-features-slider', Object.assign(keyFeaturesSliderOptionsBase, options));
};

// Tabs
const ymid = window.ymid;

const keyFeaturesTabsList = document.querySelectorAll('.js-key-features-tabs');

const keyFeaturesSliderSetActiveTab = (tabs, tab = tabs[0]) => {
  tabs.forEach((tab) => {
    if (tab.classList.contains('is-active')) {
      tab.classList.remove('is-active');
    }
  });

  tab.classList.add('is-active');

  const caret = tabs[0].querySelector('span');
  caret.style.transform = `translateX(${Math.floor(tab.offsetLeft)}px)`;
  caret.style.width = `${Math.floor(tab.offsetWidth)}px`;
};

const handleKeyFeaturesTabsInit = () => {
  // Tabs
  keyFeaturesTabsList.forEach((tabs, index) => {
    const keyFeaturesTabs = tabs.querySelectorAll('li');
    const keyFeaturesTabsIndex = index;

    keyFeaturesTabs.forEach((tab, index) => {
      const tabIndex = index;

      keyFeaturesSliderSetActiveTab(keyFeaturesTabs, tab[0]);

      tab.addEventListener('click', (e) => {
        e.preventDefault();

        keyFeaturesSliderSetActiveTab(keyFeaturesTabs, tab);

        keyFeaturesSlider[keyFeaturesTabsIndex].slideTo(tabIndex);
      });
    });
  });

  // Slide change
  keyFeaturesSlider.forEach((slider, index) => {
    const keyFeaturesTabs = keyFeaturesTabsList[index].querySelectorAll('li');

    slider.on('destroy', () => {
      keyFeaturesSliderSetActiveTab(keyFeaturesTabs);
    });

    slider.on('slideChange', (swiper) => {
      const slideIndex = swiper.activeIndex;
      const slideEvent = swiper.slides[slideIndex].dataset.eventSlide;

      // Events
      if (slideEvent) {
        try {
          dataLayer.push({ event: 'gaEvent', eventcategory: slideEvent, eventaction: 'click' });
        } catch (e) {}

        try {
          ym(ymid, 'reachGoal', slideEvent, {});
        } catch (e) {}
      }

      // Tabs
      keyFeaturesTabs.forEach((tab, index) => {
        const tabIndex = index;

        if (tabIndex === slideIndex) {
          keyFeaturesSliderSetActiveTab(keyFeaturesTabs, tab);
        }
      });
    });
  });
};

// Resize
const handleKeyFeaturesResize = () => {
  const keyFeaturesTabsList = document.querySelectorAll('.js-key-features-tabs');

  keyFeaturesTabsList.forEach((tabs) => {
    const keyFeaturesTabs = tabs.querySelectorAll('li');

    const caret = keyFeaturesTabs[0].querySelector('span');

    keyFeaturesTabs.forEach((tab) => {
      if (tab.classList.contains('is-active')) {
        caret.style.transform = `translateX(${Math.floor(tab.offsetLeft)}px)`;
        caret.style.width = Math.floor(tab.offsetWidth) + 'px';
      }
    });
  });
};

handleKeyFeaturesSliderInit();
mediaSm.addEventListener('change', handleKeyFeaturesSliderInit);

handleKeyFeaturesTabsInit();
mediaSm.addEventListener('change', handleKeyFeaturesTabsInit);

window.addEventListener('resize', handleKeyFeaturesResize);

//
// Animations
//
// Badges
let stopKeyFeaturesBadgesAnimation = [];

const handleKeyFeaturesBadgesAnimation = () => {
  const keyFeaturesBadges = document.querySelectorAll('.js-key-features-badge');

  if (mediaSm.matches) {
    stopKeyFeaturesBadgesAnimation.forEach((stop) => stop());
  } else {
    stopKeyFeaturesBadgesAnimation = Array.from(keyFeaturesBadges, (keyFeaturesBadge) => {
      return scrollAnimationProgress(keyFeaturesBadge, {
        getStart(el) {
          const headerOffset = mediaSm.matches ? 64 : 72;
          const rect = el.getBoundingClientRect();
          return rect.top + (window.scrollY - headerOffset);
        },
        getEnd(el, start) {
          return start + window.innerHeight / 1.66;
        },
        lerpValue: 0.25,
      });
    });
  }
};

handleKeyFeaturesBadgesAnimation();
mediaSm.addEventListener('change', handleKeyFeaturesBadgesAnimation);

// Wrapper
let stopKeyFeaturesWrapperAnimation = [];

const handleKeyFeaturesWrapperAnimation = () => {
  const keyFeaturesWrappers = document.querySelectorAll('.js-key-features-wrapper');

  if (mediaSm.matches) {
    stopKeyFeaturesWrapperAnimation.forEach((stop) => stop());
  } else {
    stopKeyFeaturesWrapperAnimation = Array.from(keyFeaturesWrappers, (keyFeaturesWrapper) => {
      return scrollAnimationProgress(
        keyFeaturesWrapper,
        {
          getStart(el) {
            const rect = el.getBoundingClientRect();
            return rect.top + window.scrollY - window.innerHeight * 1.33;
          },
          getEnd(el, start) {
            return start + window.innerHeight * 0.66;
          },
          lerpValue: 0.25,
        },
        eases.expoIn
      );
    });
  }
};

handleKeyFeaturesWrapperAnimation();
mediaSm.addEventListener('change', handleKeyFeaturesWrapperAnimation);

//
// QUESTIONNAIRE
//
import questionnaireInit from '~scripts/blocks/questionnaire';

questionnaireInit();

//
// CUSTOMER FEEDBACKS
//
import customerFeedbacksInit from '~scripts/blocks/customer-feedbacks';

customerFeedbacksInit();

//
// DATA SAFETY
//
if (region !== 'ai') {
  let stopDataSafetyItemsAnimation = [];

  const handleDataSafetyItemsAnimation = () => {
    const dataSafetyItems = document.querySelectorAll('.js-data-safety-item');

    if (mediaSm.matches) {
      stopDataSafetyItemsAnimation.forEach((stop) => stop());
    } else {
      stopDataSafetyItemsAnimation = Array.from(dataSafetyItems, (dataSafetyItem) => {
        return scrollAnimationProgress(dataSafetyItem, {
          getStart(el) {
            const rect = el.getBoundingClientRect();
            return rect.top + window.scrollY - window.innerHeight;
          },
          getEnd(el, start) {
            const height = el.offsetHeight;
            return start + height;
          },
        });
      });
    }
  };

  handleDataSafetyItemsAnimation();
  mediaSm.addEventListener('change', handleDataSafetyItemsAnimation);
}

//
// ENTERPRISE
//
let stopEnterpriseItemsAnimation = null;

const handleEnterpriseItemsAnimation = () => {
  const EnterpriseItems = document.getElementById('enterpriseItems');

  if (mediaSm.matches) {
    if (stopEnterpriseItemsAnimation && typeof stopEnterpriseItemsAnimation === 'function') {
      stopEnterpriseItemsAnimation();
    }
  } else {
    stopEnterpriseItemsAnimation = scrollAnimationProgress(EnterpriseItems, {
      getStart(el) {
        const rect = el.getBoundingClientRect();
        return rect.top + window.scrollY - (window.innerHeight - 110);
      },
      getEnd(el, start) {
        return start + (window.innerHeight * 1.75 + 110 + 72);
      },
    });
  }
};

handleEnterpriseItemsAnimation();
mediaSm.addEventListener('change', handleEnterpriseItemsAnimation);

//
// BENEFITS
//
if (region !== 'ai') {
  let stopBenefitsItemsAnimation = [];

  const handleBenefitsItemsAnimation = () => {
    const benefitsItems = document.querySelectorAll('.js-benefits-item');

    if (mediaSm.matches) {
      stopBenefitsItemsAnimation.forEach((stop) => stop());
    } else {
      stopBenefitsItemsAnimation = Array.from(benefitsItems, (benefitsItem) => {
        return scrollAnimationProgress(benefitsItem, {
          getStart(el) {
            const rect = el.getBoundingClientRect();
            return rect.top + window.scrollY - window.innerHeight;
          },
          getEnd(el, start) {
            const height = el.offsetHeight;
            return start + height * 0.725;
          },
        });
      });
    }
  };

  handleBenefitsItemsAnimation();
  mediaSm.addEventListener('change', handleBenefitsItemsAnimation);
}

//
// CUSTOMER CASES
//
import customerCasesInit from '~scripts/blocks/customer-cases';

if (region !== 'ai') {
  customerCasesInit();
}

//
// API SUPERPOWER
//
import apiSuperpowerInit from '~scripts/blocks/api-superpower';

apiSuperpowerInit();

//
// ENCYCLOPEDIA
//
if (region !== 'ai') {
  const body = document.body;
  const main = document.getElementById('main');
  const wrapper = document.getElementById('wrapper');
  const encyclopedia = document.getElementById('encyclopedia');

  const scroll = {
    handle() {
      if (window.scrollY > wrapper.offsetHeight) {
        body.style.paddingBottom = null;
        encyclopedia.style.position = 'static';
      } else {
        body.style.paddingBottom = `${encyclopedia.offsetHeight}px`;
        encyclopedia.style.position = 'fixed';
      }
    },
    on() {
      this.handle();

      document.addEventListener('scroll', this.handle);
      window.addEventListener('resize', this.handle);
    },
    off() {
      body.style.paddingBottom = null;
      encyclopedia.style.position = 'static';

      document.removeEventListener('scroll', this.handle);
      window.removeEventListener('resize', this.handle);
    },
  };

  // Scroll
  window.addEventListener('DOMContentLoaded', () => {
    if (!mediaSm.matches) {
      scroll.on();
    }

    mediaSm.addEventListener('change', () => {
      if (!mediaSm.matches) {
        scroll.on();
      } else {
        scroll.off();
      }
    });
  });

  window.addEventListener('load', () => {
    if (!mediaSm.matches) {
      scroll.handle();
    }
  });

  // Animation
  let stopEncyclopediaAnimation = null;

  const handleEncyclopediaAnimation = () => {
    if (mediaSm.matches) {
      if (stopEncyclopediaAnimation && typeof stopEncyclopediaAnimation === 'function') {
        stopEncyclopediaAnimation();
      }
    } else {
      stopEncyclopediaAnimation = scrollAnimationProgress(main, {
        getStart() {
          const rect = wrapper.getBoundingClientRect();
          return rect.bottom + (window.scrollY - window.innerHeight);
        },
        getEnd(el, start) {
          return start + window.innerHeight - 72;
        },
        lerpValue: 1,
      });
    }
  };

  handleEncyclopediaAnimation();
  mediaSm.addEventListener('change', handleEncyclopediaAnimation);
}

//
// DEMO REQUEST FORM
//
const demoRequestForms = document.querySelectorAll('.js-demo-request-form');

demoRequestForms.forEach((form) => {
  initRequestForm(form);
});

//
// SUBSCRIBE FORM
//
if (region !== 'ai') {
  const formWrapper = document.querySelector('.js-form-wrapper');

  new Vue({
    el: formWrapper,
    components: {
      SubscribeForm
    },
  });
}
